<div *ngIf="show" class="upsell-confirm-overlay">
  <div class="overlay-backdrop"></div>
  <div class="confirmation-content" fxLayout="column" fxLayoutAlign="center center">
    <!-- Icon and Text - Desktop layout (hidden on mobile) -->
    <div class="confirmation-header desktop-layout" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px" fxHide.xs>
      <div class="warning-icon">
        <img [src]="iconSrc" [attr.alt]="iconAlt || ('upsellBuyConfirm.iconAlt' | translate)">
      </div>
      <div class="confirmation-text">
        <p *ngIf="!appliedDiscount">
          {{ confirmationTextPrefix || ('billing.addonConfirmationTextPrefix' | translate) }}
          <span>{{ (formattedPrice || originalPrice) | priceNotation }}</span>
          {{ confirmationTextSuffix || ('billing.addonConfirmationTextSuffix' | translate) }}
        </p>
        <p *ngIf="appliedDiscount">
          {{ confirmationTextPrefix || ('billing.addonConfirmationTextPrefix' | translate) }}
          <span class="discount-price-display">
            <span class="original-price">{{ originalPrice }}</span>
            <span class="discounted-price">{{ discountedPrice }}</span>
          </span>
          {{ confirmationTextSuffix || ('billing.addonConfirmationTextSuffix' | translate) }}
        </p>
      </div>
    </div>

    <!-- Icon and Text - Mobile layout (hidden on desktop) -->
    <div class="confirmation-header mobile-layout" fxLayout="column" fxLayoutAlign="center center" fxHide.gt-xs>
      <div class="warning-icon">
        <img [src]="iconSrc" [attr.alt]="iconAlt || ('upsellBuyConfirm.iconAlt' | translate)">
      </div>
      <div class="confirmation-text">
        <p *ngIf="!appliedDiscount">
          {{ confirmationTextPrefix || ('billing.addonConfirmationTextPrefix' | translate) }}
          <span>{{ (formattedPrice || originalPrice) | priceNotation }}</span>
          {{ confirmationTextSuffix || ('billing.addonConfirmationTextSuffix' | translate) }}
        </p>
        <p *ngIf="appliedDiscount">
          {{ confirmationTextPrefix || ('billing.addonConfirmationTextPrefix' | translate) }}
          <span class="discount-price-display">
            <span class="original-price">{{ originalPrice }}</span>
            <span class="discounted-price">{{ discountedPrice }}</span>
          </span>
          {{ confirmationTextSuffix || ('billing.addonConfirmationTextSuffix' | translate) }}
        </p>
      </div>
    </div>

    <!-- Discount Code Section (only shown when feature flag is enabled) -->
    <div *ngIf="enableDiscount" class="discount-code-section">
      <!-- Discount Code Link (shown when no discount applied and input is not shown) -->
      <div *ngIf="!appliedDiscount && !showingDiscountInput" class="discount-code-link">
        <a href="#" class="discount-code-text" (click)="showDiscountInput.emit(); $event.preventDefault()">{{ 'upsellBuyConfirm.haveDiscountCode' | translate }}</a>
      </div>

      <!-- Discount Applied Success Message -->
      <div *ngIf="appliedDiscount" class="discount-success-message">
        <div class="discount-applied-text">
          <span class="success-text">{{ getAppliedDiscountText() }}</span>
          <a href="#" class="delete-code-link" (click)="clearDiscount.emit(); $event.preventDefault()">{{ 'upsellBuyConfirm.deleteCode' | translate }}</a>
        </div>
      </div>

      <!-- Discount Code Input (shown when link is clicked and no discount applied) -->
      <div *ngIf="!appliedDiscount && showingDiscountInput" class="discount-code-input-container">
        <div class="input-row">
          <input
            type="text"
            class="discount-code-input"
            [placeholder]="'upsellBuyConfirm.addDiscountCodePlaceholder' | translate"
            [value]="discountCodeValue"
            (input)="discountCodeChange.emit($any($event.target).value)"
            (keydown)="discountKeyPress.emit($event)"
            #discountInput>
          <button
            type="button"
            class="apply-discount-btn"
            (click)="applyDiscount.emit()"
            [disabled]="!discountCodeValue.trim() || validatingDiscount"
            [trackClick]="{ page: 'Apply Discount Code Button Clicked', location: trackLocation }">
            <mat-spinner *ngIf="validatingDiscount" diameter="16" class="button-spinner"></mat-spinner>
            <span *ngIf="!validatingDiscount">{{ 'upsellBuyConfirm.applyButton' | translate | uppercase }}</span>
          </button>
        </div>

        <!-- Discount Validation Error (shown directly below input) -->
        <div *ngIf="discountValidationError" class="discount-error-message">
          {{ discountValidationError }}
        </div>
      </div>
    </div>

    <!-- Action Buttons - Desktop layout (hidden on mobile) -->
    <div class="confirmation-actions desktop-layout" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px" fxHide.xs>
      <button
        mat-stroked-button
        class="confirm-btn"
        (click)="cancel.emit()"
        [disabled]="loading"
        [trackClick]="{ page: 'Cancel Button Clicked', location: trackLocation }">
        {{ (cancelLabel || ('upsellBuyConfirm.cancelLabel' | translate)) | uppercase }}
      </button>
      <button
        mat-stroked-button
        color="accent"
        class="confirm-btn cancel-btn"
        [ngClass]="{'loading': loading}"
        (click)="confirm.emit()"
        [disabled]="isConfirmDisabled"
        [trackClick]="{ page: 'Confirm Button Clicked', location: trackLocation }">
        <mat-spinner *ngIf="loading" diameter="16" class="button-spinner"></mat-spinner>
        <span *ngIf="!loading">{{ (confirmLabel || ('upsellBuyConfirm.confirmLabel' | translate)) | uppercase }}</span>
      </button>
    </div>

    <!-- Action Buttons - Mobile layout (hidden on desktop) -->
    <div class="confirmation-actions mobile-layout" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px" fxHide.gt-xs>
      <button
        mat-stroked-button
        color="accent"
        class="confirm-btn cancel-btn"
        [ngClass]="{'loading': loading}"
        (click)="confirm.emit()"
        [disabled]="isConfirmDisabled"
        [trackClick]="{ page: 'Confirm Button Clicked', location: trackLocation }">
        <mat-spinner *ngIf="loading" diameter="16" class="button-spinner"></mat-spinner>
        <span *ngIf="!loading">{{ (confirmLabel || ('upsellBuyConfirm.confirmLabel' | translate)) | uppercase }}</span>
      </button>
      <button
        mat-stroked-button
        class="cancel-btn-mobile"
        (click)="cancel.emit()"
        [disabled]="loading"
        [trackClick]="{ page: 'Cancel Button Clicked', location: trackLocation }">
        {{ (cancelLabel || ('upsellBuyConfirm.cancelLabel' | translate)) | uppercase }}
      </button>
    </div>
  </div>
</div>
